import en from "./en-CA";
import fr from "./fr-CA";

export default{
    ...en,
    ...fr,
}